// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountFormController from "./account_form_controller"
application.register("account-form", AccountFormController)

import AppController from "./app_controller"
application.register("app", AppController)

import ConfirmationModalController from "./confirmation_modal_controller"
application.register("confirmation-modal", ConfirmationModalController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DynamicFieldsController from "./dynamic_fields_controller"
application.register("dynamic-fields", DynamicFieldsController)

import FacetedSearchController from "./faceted_search_controller"
application.register("faceted-search", FacetedSearchController)

import FormController from "./form_controller"
application.register("form", FormController)

import PasswordInputController from "./password_input_controller"
application.register("password-input", PasswordInputController)

import PhoneFormController from "./phone_form_controller"
application.register("phone-form", PhoneFormController)

import RemoveOnDisconnectController from "./remove_on_disconnect_controller"
application.register("remove-on-disconnect", RemoveOnDisconnectController)

import TabSelectController from "./tab_select_controller"
application.register("tab-select", TabSelectController)

import TableController from "./table_controller"
application.register("table", TableController)

import TablePaginatorController from "./table_paginator_controller"
application.register("table-paginator", TablePaginatorController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
